// src/components/NewsWidget.js - Widget actualités pour le Dashboard
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NewsCard from './NewsCard';
import '../styles/NewsCard.css';

const NewsWidget = ({ limit = 3 }) => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadRecentNews();
  }, []);

  const loadRecentNews = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/news', {
        params: { limit },
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      });

      setNews(response.data.data);
    } catch (err) {
      console.error('Erreur lors du chargement des actualités:', err);
      setError('Impossible de charger les actualités.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ margin: '0 0 20px 0', color: '#2c3e50' }}>
          📰 Dernières Actualités
        </h2>
        <div className="news-loading">
          Chargement...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ margin: '0 0 20px 0', color: '#2c3e50' }}>
          📰 Dernières Actualités
        </h2>
        <div className="news-error">{error}</div>
      </div>
    );
  }

  return (
    <div style={{
      background: 'white',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      marginTop: '30px'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
      }}>
        <h2 style={{ margin: 0, color: '#2c3e50', fontSize: '1.5rem' }}>
          📰 Dernières Actualités
        </h2>
        <button
          onClick={() => navigate('/news')}
          style={{
            padding: '8px 16px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '0.9rem',
            transition: 'all 0.2s'
          }}
          onMouseOver={(e) => e.target.style.background = '#764ba2'}
          onMouseOut={(e) => e.target.style.background = '#667eea'}
        >
          Voir toutes les actualités →
        </button>
      </div>

      {news.length > 0 ? (
        <div className="news-grid">
          {news.map((article) => (
            <NewsCard key={article.id} news={article} />
          ))}
        </div>
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          color: '#999'
        }}>
          <p style={{ fontSize: '2rem', margin: '0 0 12px 0' }}>📭</p>
          <p style={{ margin: 0 }}>Aucune actualité disponible</p>
        </div>
      )}
    </div>
  );
};

export default NewsWidget;

